import { render, staticRenderFns } from "./IngredientItem.vue?vue&type=template&id=796d623a&scoped=true&lang=pug&"
import script from "./IngredientItem.vue?vue&type=script&lang=js&"
export * from "./IngredientItem.vue?vue&type=script&lang=js&"
import style0 from "./IngredientItem.vue?vue&type=style&index=0&id=796d623a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "796d623a",
  null
  
)

export default component.exports